import React, { useEffect, useState } from 'react'
import { useShoppingCart } from '../../../context/CartContext.tsx/ShoppingCartContext';
import Coupon from './Coupon';
import Modal from 'react-modal';
import { useLottie } from 'lottie-react';
import order_confirm from '../../../assets/lottie/order_confirm.json';
import  logo  from '../../../assets/success.gif'

interface couponAppliedProps {
    amount_off?: number | any;
    cashback?:number | any;
    free_variant_price?:number | any;
    coupon?: string | any;
    message?: string | any;
    cart_id: number | any;
}

const CouponApplied = (props: couponAppliedProps) => {



    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: order_confirm,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    const { View } = useLottie(defaultOptions);
    // if (props.coupon != null) {

    const { removeCoupon, closePopup } = useShoppingCart();

    const [isCoupon, setIsCoupon] = useState(false);

    useEffect(() => {
        if (props.coupon && props.coupon !== '') {
            setIsCoupon(true);
        } else {
            setIsCoupon(false);
        }
    }, [props.coupon]);
    // if (props.coupon != null) {

    useEffect(() => {
        document.body.style.overflow = isCoupon ? 'hidden' : 'unset';
      
        return () => {
          document.body.style.overflow = 'unset';
        };
      }, [isCoupon]);



    return (

        <>
            {props.coupon !== '' && isCoupon === true && 
             <div className="couponSuccessBackdrop" onClick={() => { setIsCoupon(false) }}>
                <div className="couponBackdeop" >
                <button onClick={() => { setIsCoupon(false) }} className="discountPopupClose"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.99032 0.990242C1.79139 0.990294 1.59699 1.04967 1.43198 1.16079C1.26697 1.2719 1.13884 1.4297 1.06399 1.61401C0.98913 1.79832 0.970941 2.00077 1.01175 2.19548C1.05255 2.39018 1.15049 2.56829 1.29305 2.70704L6.58602 8.00001L1.29305 13.293C1.19708 13.3851 1.12046 13.4955 1.06767 13.6176C1.01489 13.7397 0.987001 13.8712 0.985647 14.0042C0.984294 14.1373 1.0095 14.2692 1.05979 14.3924C1.11008 14.5156 1.18444 14.6275 1.27852 14.7216C1.3726 14.8157 1.4845 14.89 1.60768 14.9403C1.73086 14.9906 1.86283 15.0158 1.99587 15.0144C2.12891 15.0131 2.26034 14.9852 2.38247 14.9324C2.5046 14.8796 2.61497 14.803 2.70712 14.707L8.00008 9.41407L13.2931 14.707C13.3852 14.803 13.4956 14.8796 13.6177 14.9324C13.7398 14.9852 13.8713 15.0131 14.0043 15.0145C14.1373 15.0158 14.2693 14.9906 14.3925 14.9403C14.5157 14.89 14.6276 14.8157 14.7217 14.7216C14.8157 14.6275 14.8901 14.5156 14.9404 14.3924C14.9907 14.2692 15.0159 14.1373 15.0145 14.0042C15.0132 13.8712 14.9853 13.7397 14.9325 13.6176C14.8797 13.4955 14.8031 13.3851 14.7071 13.293L9.41415 8.00001L14.7071 2.70704C14.8516 2.56658 14.9503 2.38574 14.9903 2.18822C15.0302 1.9907 15.0096 1.78571 14.931 1.60013C14.8525 1.41454 14.7197 1.25701 14.5501 1.14818C14.3805 1.03935 14.182 0.984302 13.9806 0.990242C13.7208 0.997983 13.4742 1.10656 13.2931 1.29298L8.00008 6.58595L2.70712 1.29298C2.61393 1.19718 2.50248 1.12104 2.37937 1.06904C2.25625 1.01704 2.12396 0.99025 1.99032 0.990242Z" fill="#4F4F4F"></path></svg></button>
                    <div className='dialogTextWrapper'>
                        <div className='couponLogoWrapper'>
                            <img src={logo} alt="logo" />
                        </div>
                        <p className='couponLable'>'{props.coupon}' applied</p>
                        {/* { parseInt(props.amount_off) > 0 && <p className='savedAmount'>You Saved Rs. {props.amount_off}</p>}
                        { parseInt(props.cashback) > 0 && <p className='savedAmount'>You will get Rs. {props.cashback} cashback</p>}
                        { parseInt(props.free_variant_price) > 0 && <p className='savedAmount'>You Saved Rs. {props.free_variant_price}</p>} */}
                        <p className='savedAmount'>{props.message}</p>
                        {/* <p className='saveAmountCode'>{props.message}</p> */}
                    </div>
                    
                        <button className='thankyouButton' onClick={() => { setIsCoupon(false) }}>Woohoo! Thank you!</button>
                    
                </div>
            </div>}

            <div className="alreadyApplied">
                <div className="offerLeftContent">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.53 8.87L18.01 7.35001C17.75 7.09 17.54 6.58001 17.54 6.22001V4.06C17.54 3.18 16.82 2.46 15.94 2.46H13.79C13.43 2.46 12.92 2.25 12.66 1.99L11.14 0.470005C10.52 -0.149995 9.5 -0.149995 8.88 0.470005L7.34 1.99C7.09 2.25 6.58 2.46 6.21 2.46H4.06C3.18 2.46 2.46 3.18 2.46 4.06V6.21C2.46 6.57 2.25 7.08 1.99 7.34L0.470005 8.86C-0.149995 9.48 -0.149995 10.5 0.470005 11.12L1.99 12.64C2.25 12.9 2.46 13.41 2.46 13.77V15.92C2.46 16.8 3.18 17.52 4.06 17.52H6.21C6.57 17.52 7.08 17.73 7.34 17.99L8.86 19.51C9.48 20.13 10.5 20.13 11.12 19.51L12.64 17.99C12.9 17.73 13.41 17.52 13.77 17.52H15.92C16.8 17.52 17.52 16.8 17.52 15.92V13.77C17.52 13.41 17.73 12.9 17.99 12.64L19.51 11.12C20.16 10.51 20.16 9.49 19.53 8.87ZM6 7C6 6.45 6.45 6 7 6C7.55 6 8 6.45 8 7C8 7.55 7.56 8 7 8C6.45 8 6 7.55 6 7ZM7.53 13.53C7.38 13.68 7.19 13.75 7 13.75C6.81 13.75 6.62001 13.68 6.47001 13.53C6.18001 13.24 6.18001 12.76 6.47001 12.47L12.47 6.47001C12.76 6.18001 13.24 6.18001 13.53 6.47001C13.82 6.76 13.82 7.24 13.53 7.53L7.53 13.53ZM13 14C12.44 14 11.99 13.55 11.99 13C11.99 12.45 12.44 12 12.99 12C13.54 12 13.99 12.45 13.99 13C13.99 13.55 13.55 14 13 14Z" fill="#3D6AAE"></path></svg>

                </div>

                <div className='coupponInfoWrapper'>
                    <div className="coupponInfo">
                        <p className="coupenText">'{props.coupon}' applied </p>
                        <p className="coupenMesaage">{props.message}</p>
                    </div>
                    <div className='removeCoupon'>
                        <button onClick={() => { removeCoupon(props.cart_id); closePopup(); }}>
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.5 12L12.5 4" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12.5 12L4.5 4" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                        </button>
                    </div>
                </div>
            </div>
        </>

    )

    // } else {
    //     return (
    //         <div className="offer-section apply_offer_modal">
    //             <div className="flex items-center justify-between flex-1 button_content">
    //                 <div className="offer__leftContent">
    //                     <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                         <path d="M20.03 8.87L18.51 7.35001C18.25 7.09001 18.04 6.58001 18.04 6.22001V4.06C18.04 3.18 17.32 2.46 16.44 2.46H14.29C13.93 2.46 13.42 2.25 13.16 1.99L11.64 0.470005C11.02 -0.149995 10 -0.149995 9.38 0.470005L7.84 1.99C7.59 2.25 7.08 2.46 6.71 2.46H4.56C3.68 2.46 2.96 3.18 2.96 4.06V6.21C2.96 6.57 2.75 7.08 2.49 7.34L0.970005 8.86C0.350005 9.48 0.350005 10.5 0.970005 11.12L2.49 12.64C2.75 12.9 2.96 13.41 2.96 13.77V15.92C2.96 16.8 3.68 17.52 4.56 17.52H6.71C7.07 17.52 7.58 17.73 7.84 17.99L9.36 19.51C9.98 20.13 11 20.13 11.62 19.51L13.14 17.99C13.4 17.73 13.91 17.52 14.27 17.52H16.42C17.3 17.52 18.02 16.8 18.02 15.92V13.77C18.02 13.41 18.23 12.9 18.49 12.64L20.01 11.12C20.66 10.51 20.66 9.49 20.03 8.87ZM6.5 7C6.5 6.45 6.95 6 7.5 6C8.05 6 8.5 6.45 8.5 7C8.5 7.55 8.06 8 7.5 8C6.95 8 6.5 7.55 6.5 7ZM8.03 13.53C7.88 13.68 7.69 13.75 7.5 13.75C7.31 13.75 7.12001 13.68 6.97001 13.53C6.68001 13.24 6.68001 12.76 6.97001 12.47L12.97 6.47001C13.26 6.18001 13.74 6.18001 14.03 6.47001C14.32 6.76001 14.32 7.24 14.03 7.53L8.03 13.53ZM13.5 14C12.94 14 12.49 13.55 12.49 13C12.49 12.45 12.94 12 13.49 12C14.04 12 14.49 12.45 14.49 13C14.49 13.55 14.05 14 13.5 14Z" fill="#469DA1" />
    //                     </svg>
    //                     <p className="coupen_text">Apply Offer</p>
    //                 </div>
    //                 <div className="arrow_svg">
    //                     {/* <!-- <span id="offerAwait">2 Offer Awaiting</span>  --> */}
    //                     <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                         <path d="M1.43994 12.28L5.78661 7.9333C6.29994 7.41997 6.29994 6.57997 5.78661 6.06664L1.43994 1.71997" stroke="#3D6AAE" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    //                     </svg>

    //                 </div>
    //             </div>
    //             <p className="codeInput_error"></p>
    //         </div>
    //     )
    // }

}

export default CouponApplied
